import './calc.pug'

export default () => {

}